import React from "react";

// Component imports
import { SearchIcon } from "@icons";
import { TextField, InputAdornment } from "@material";

// Misc Imports

import { useTranslation } from "@i18n";
import { makeStyles } from "@styles";

const useStyles = (styleProps) =>
  makeStyles((theme: Theme) => ({
    searchBar: {
      width: styleProps.width || "100%",
      maxWidth: styleProps.maxWidth || "100%",
    },
    root: {
      backgroundColor: theme.palette.colors.background.lightGrey,
      minHeight: 44,
      maxHeight: 44,
      padding: 8,
      borderRadius: 8,
      border: `1px solid transparent`,
      transitionProperty: "border-color, background-color",
      transitionDuration: "0.3s",
      "&:hover": {
        borderColor: theme.palette.colors.border.light,
      },
      "&.Mui-focused": {
        borderColor: theme.palette.colors.border.light,
        backgroundColor: theme.palette.white,
      },
      "&&&:before": {
        borderBottom: "none",
      },
      "&&:after": {
        borderBottom: "none",
      },
      "&&&&:hover:before": {
        borderBottom: "none",
      },
    },
    input: {
      fontSize: 15,
      fontWeight: 400,
      color: theme.palette.black,
      "&::placeholder": {
        color: theme.palette.colors.text.subheader,
        opacity: 1,
      },
    },
  }));

type Props = {
  width?: number | string;
  maxWidth?: number | string;
  onChange?: any;
  value?: string;
  placeholder?: string;
  id?: string;
};

export function SearchField({
  width,
  maxWidth,
  onChange,
  value,
  placeholder,
  id,
}: Props) {
  const styleProps = { width, maxWidth };
  const classes: any = useStyles(styleProps)({});
  const { t } = useTranslation("common");

  return (
    <TextField
      id={id || "offer-search"}
      type="search"
      placeholder={placeholder ?? t("search")}
      value={value}
      onChange={onChange}
      className={classes.searchBar}
      InputProps={{
        classes: { root: classes.root, input: classes.input },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon width={16} style={{ marginLeft: 3, marginRight: 5 }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
